class NewsSubscription {
  constructor() {
    this.captchaRefreshBtn = document.querySelector('.news-subscription__captcha-refresh');
    this.captchaImage = document.querySelector('.news-subscription__captcha-image');
    this.form = document.querySelector('.news-subscription__form');
    this.titleEl = document.querySelector('.news-subscription__title');
    this.subtitleEl = document.querySelector('.news-subscription__subtitle');
    this.currentCaptchaId = null;
    this.init();
  }

  init() {
    if (!this.form) return;

    if (this.captchaRefreshBtn) {
      this.captchaRefreshBtn.addEventListener('click', this.refreshCaptcha.bind(this));
    }

    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    if (this.captchaImage) {
      this.refreshCaptcha();
    }
  }

  refreshCaptcha() {
    if (!this.captchaImage) return;

    const ajaxUrl = backendData?.ajaxUrl;

    fetch(`${ajaxUrl}?action=newsletter_captcha&action_type=get_id&t=${Date.now()}`, {
      method: 'GET',
      cache: 'no-cache',
    })
      .then(response => response.json())
      .then(data => {
        if (data.success && data.data.captcha_id) {
          this.currentCaptchaId = data.data.captcha_id;

          this.captchaImage.src = `${ajaxUrl}?action=newsletter_captcha&captcha_id=${this.currentCaptchaId}&t=${Date.now()}`;
          this.captchaImage.style.display = 'block';

          const captchaInput = this.form?.querySelector('.news-subscription__input--captcha');
          if (captchaInput) {
            captchaInput.value = '';
          }
        } else {
          console.error('Error getting captcha_id');
        }
      })
      .catch(error => {
        console.error('Error loading captcha:', error);
      });
  }

  handleSubmit(event) {
    event.preventDefault();
    
    const emailInput = this.form.querySelector('input[name="email"]');
    const captchaInput = this.form.querySelector('input[name="captcha"]');
    const submitButton = this.form.querySelector('button[type="submit"]');
    const enteredCaptchaRaw = captchaInput?.value.trim();

    if (!enteredCaptchaRaw) {
      if (window.alertNotification) {
        const message =
          backendData?.translations?.newsletter_subscribe_empty_captcha ||
          'Пожалуйста, введите код капчи';
        window.alertNotification.error(message);
      }
      captchaInput?.focus();
      return;
    }

    if (!this.currentCaptchaId) {
      if (window.alertNotification) {
        const message =
          backendData?.translations?.newsletter_subscribe_captcha_error ||
          'Ошибка капчи. Пожалуйста, обновите капчу и попробуйте еще раз.';
        window.alertNotification.error(message);
      }
      this.refreshCaptcha();
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent =
        backendData?.translations?.newsletter_subscribe_button_sending || '...';
    }

    const formData = new FormData();
    formData.append('action', 'newsletter_subscribe');
    formData.append('email', emailInput.value);
    formData.append('captcha', enteredCaptchaRaw);
    formData.append('captcha_id', this.currentCaptchaId);
    formData.append('nonce', backendData?.nonce);
    const ajaxUrl = backendData?.ajaxUrl;

    fetch(ajaxUrl, {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          const successMessage =
            data.data.message ||
            backendData?.translations?.newsletter_subscribe_success ||
            'Спасибо за подписку!';

          if (window.alertNotification) {
            window.alertNotification.success(successMessage);
          }

          if (this.form) {
            this.form.style.display = 'none';
          }

          const thanksTitle =
            backendData?.translations?.newsletter_subscribe_thanks_title ||
            'Спасибо за подписку!';
          const thanksText =
            backendData?.translations?.newsletter_subscribe_thanks_text ||
            'Теперь вы будете первыми узнавать о наших новостях и акциях.';

          if (this.titleEl) {
            this.titleEl.textContent = thanksTitle;
          }

          if (this.subtitleEl) {
            this.subtitleEl.textContent = thanksText;
          }
        } else {
          if (window.alertNotification) {
            const errorMessage =
              data.data?.message ||
              backendData?.translations?.newsletter_subscribe_server_error ||
              'Произошла ошибка. Попробуйте позже.';
            window.alertNotification.error(errorMessage);
          }
          this.refreshCaptcha();
        }
      })
      .catch(error => {
        console.error('Error:', error);
        if (window.alertNotification) {
          const requestErrorMessage =
            backendData?.translations?.newsletter_subscribe_request_error ||
            'Произошла ошибка при отправке. Попробуйте позже.';
          window.alertNotification.error(requestErrorMessage);
        }
        this.refreshCaptcha();
      })
      .finally(() => {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent =
            backendData?.translations?.newsletter_subscribe_button_default || 'Подписаться';
        }
      });
  }
}

new NewsSubscription();
